<div
  [class.selected-poi]="selected()"
  [ngClass]="{
    'selected-poi': selected(),
    qrCode: link(),
    'inline-flex items-center gap-2 font-bold align-middle': true,
  }"
>
  @if (poi().file) {
    <cue-image class="poi-icon" [src]="poi().file" />
  } @else {
    <cue-icon class="poi-icon" [icon]="ICONS.cueQrCode" />
  }

  <span>{{ poi().name | localizedString }}</span>
</div>
